import React, { useCallback, useEffect } from "react";
import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Paper as MuiPaper,
  CardContent,
  Box,
  Chip,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { useDialog } from "../../../../contexts/DialogContext";
import { Link } from "react-router-dom";

import EditDelete from "../../../../components/EditDelete";
import Toolbar from "../../../../components/Toolbar";
import useWindowDimensions from "../../../../utils/windowDimensions";
import AdvanceFilter from "./AdvanceFilter";
import useTenant from "../../../../hooks/useTenant";
import useMainContentDimensions from "../../../../utils/mainContentDimensions";
import UploadLogo from "./UploadLogo";
import UploadInLog from "./UploadInvoLog";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

const breadCrump = () => {
  return (
    <Breadcrumbs aria-label="Breadcrumb" mt={2}>
      <Typography>Cpanel</Typography>
      <Typography>Franchise</Typography>
      <Typography>List</Typography>
    </Breadcrumbs>
  );
};

const CustomDataGrid = (props) => {
  const { isLoadingDownload, downloadFileType } = useTenant();
  const { getAllTenant, getTenant, tenants } = useTenant();

  console.log(tenants, "ttewannan");

  const { height } = useWindowDimensions();
  const { width: mainContentWidth } = useMainContentDimensions();

  const {
    editPage,
    addPage,
    trans,
    rows,
    rowCount,
    isLoading,
    id,
    handleSortModelChange,
    sortModel,
    payload,
    setPayload,
    downloadFile,
    openDownloadDialog,
    refreshPage,
    setFilterResetFunc,
    paginationModel,
    paginationMeta,
    paging,
    onPaginationModelChange,
  } = props;
  console.log(rowCount, "loading child component");
  const { openDialog } = useDialog();

  // const businessType = (type) => {
  //   if (type == "MULTI_SERVICE_OPERATOR") {
  //     return <Chip label="Active" color="primary" />;
  //   }
  // };

  const fetchData = async () => {
    await getAllTenant(payload);
  };

  useEffect(() => {
    fetchData();
  }, [payload]);

  const uploadLogoClick = useCallback((tenantId, actionType) => {
    console.log(actionType, "tenantId for actionType logo");
    if (actionType == "upload_logo") {
      return openDialog("upload_logo", "Upload Logo", <UploadLogo tenantId={tenantId} />);
    } else {
      return openDialog(
        "upload_invoice_logo",
        "Upload Invoice Logo",
        <UploadInLog tenantId={tenantId} />,
      );
    }
  }, []);

  const columns = [
    {
      field: "action",
      headerName: "Action",
      filter: false,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e) => {
          e.stopPropagation(); // don't select this row after clicking
          const api = params.api;
          const thisRow = {};
          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach((c) => (thisRow[c.field] = params.getValue(params.id, c.field)));
          console.log(thisRow, "thisRow");
          console.log(params.value, "paraaaa");
        };

        const isMultiServiceOperator = params.row.businessType === "MULTI_SERVICE_OPERATOR";

        const menus = ["edit", "general_settings", "email_settings", "sms_settings"];
        if (isMultiServiceOperator) {
          menus.push("upload_logo");
          menus.push("invoice_logo");
        }

        return (
          <EditDelete
            rowClick={onClick}
            editPage={editPage}
            uploadLogoClick={uploadLogoClick}
            menus={menus}
            rowId={params.id}
          />
        );
      },
    },
    {
      field: "tenantName",
      headerName: "Franchise Name",
      renderCell: (params) => (
        <Link to={"/cpanel/tenant/details?id=" + params.id}>{params.value}</Link>
      ),
      width: 200,
    },
    {
      field: "userName",
      headerName: "User Name",
      width: 200,
    },
    {
      field: "onlineUserCount",
      renderCell: (params) => (
        <Typography variant="span" sx={{ color: "green" }}>
          {params.value}
        </Typography>
      ),
      headerName: "Online Users",
      width: 200,
    },
    {
      field: "activeUserCount",
      renderCell: (params) => (
        <Typography variant="span" sx={{ color: "blue" }}>
          {params.value}
        </Typography>
      ),
      headerName: "Active Users",
      width: 200,
    },
    {
      field: "mobileNo",
      headerName: "Mobile",
      width: 130,
    },
    {
      field: "emailId",
      headerName: "Mail Id",
      width: 300,
    },
    {
      field: "gstNo",
      headerName: "GST Number",
      width: 150,
    },
    {
      field: "businessType",
      headerName: "Business Type",
      width: 300,
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
    },
  ];

  const openFilterDialog = () => {
    return openDialog(
      "advance_filter",
      "Advance Filter",
      <AdvanceFilter
        payload={payload}
        setPayload={setPayload}
        setFilterResetFunc={setFilterResetFunc}
      />,
    );
  };

  return (
    <Card sx={{ width: "100%", maxWidth: mainContentWidth - 64 }}>
      <CardHeader
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack on small screens
          justifyContent: "space-between",
          alignItems: "flex-start", // Adjust alignment as needed
        }}
        action={
          <Toolbar
            addPage={addPage}
            downloadFile={downloadFile}
            openDownloadDialog={openDownloadDialog}
            openFilterDialog={openFilterDialog}
            isLoadingDownload={isLoadingDownload}
            downloadFileType={downloadFileType}
            refreshPage={refreshPage}
          />
        }
        title={
          <Typography variant="h6" sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}>
            {trans("franchise_list")}
          </Typography>
        }
        subheader={<Box sx={{ display: "flex", flexWrap: "wrap" }}>{breadCrump()}</Box>}
      />
      <CardContent sx={{ height: height - 180, display: "flex", flexDirection: "column" }}>
        <Box sx={{ flex: 1, overflow: "auto" }}>
          {" "}
          <DataGrid
            initialState={{
              pagination: { paginationModel: { pageSize: 100 } },
            }}
            rowCount={rowCount}
            getRowId={(row) => row[id]}
            columns={columns}
            rows={rows}
            page={paging.pageNumber}
            pageSize={paging.pageSize}
            paginationMeta={paginationMeta}
            loading={isLoading}
            pageSizeOptions={[25, 50, 100]}
            paginationMode="server"
            onPaginationModelChange={onPaginationModelChange}
            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortModelChange}
            paginationModel={paginationModel}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
            }
            sx={{
              "& .MuiDataGrid-row.even-row": {
                backgroundColor: "#f9f9f9", // Light gray for even rows
              },
              "& .MuiDataGrid-row.odd-row": {
                backgroundColor: "#ffffff", // White for odd rows
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};
CustomDataGrid.propTypes = {
  editPage: PropTypes.func.isRequired,
  addPage: PropTypes.func.isRequired,
  trans: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  rowCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  handleSortModelChange: PropTypes.func.isRequired,
  sortModel: PropTypes.object.isRequired,
};
export default CustomDataGrid;
